import Icon from '../components/Icon.vue'

Icon.register({"wine-glass":{"width":288,"height":512,"paths":[{"d":"M287.4 192.7L271.4 14.6C270.7 6.3 263.9 0 255.7 0H32.3C24.1 0 17.3 6.3 16.6 14.6L0.6 192.7C-6.6 272.7 51.3 341.6 128 350.3V480H74.1C49.6 480 40.9 512 54.1 512H233.9C247 512 238.4 480 213.9 480H160V350.3C236.7 341.5 294.6 272.7 287.4 192.7zM226.2 48L233.4 128H54.6L61.8 48H226.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/wine-glass.js
// module id = null
// module chunks = 